var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_302_981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.6055 15.8203H43.9453V4.39453C43.9453 1.97139 41.9739 0 39.5508 0H4.39453C1.97139 0 0 1.97139 0 4.39453V39.5508C0 41.9739 1.97139 43.9453 4.39453 43.9453H29.4922V45.6055C29.4922 48.0286 31.4636 50 33.8867 50H45.6055C48.0286 50 50 48.0286 50 45.6055V20.2148C50 17.7917 48.0286 15.8203 45.6055 15.8203ZM2.92969 4.39453C2.92969 3.58682 3.58682 2.92969 4.39453 2.92969H39.5508C40.3585 2.92969 41.0156 3.58682 41.0156 4.39453V8.78906H27.832C27.5665 8.78906 27.3061 8.86123 27.0784 8.99785L22.5435 11.7188H2.92969V4.39453ZM29.4922 20.2148V41.0156H4.39453C3.58682 41.0156 2.92969 40.3585 2.92969 39.5508V14.6484H22.9492C23.2147 14.6484 23.4752 14.5763 23.7028 14.4396L28.2378 11.7188H41.0156V15.8203H33.8867C31.4636 15.8203 29.4922 17.7917 29.4922 20.2148ZM47.0703 45.6055C47.0703 46.4132 46.4132 47.0703 45.6055 47.0703H33.8867C33.079 47.0703 32.4219 46.4132 32.4219 45.6055V44.1406H47.0703V45.6055ZM47.0703 41.2109H32.4219V20.2148C32.4219 19.4071 33.079 18.75 33.8867 18.75H45.6055C46.4132 18.75 47.0703 19.4071 47.0703 20.2148V41.2109Z",
    fill: "#FBB132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.6992 21.6797H37.793C36.984 21.6797 36.3281 22.3355 36.3281 23.1445C36.3281 23.9535 36.984 24.6094 37.793 24.6094H41.6992C42.5082 24.6094 43.1641 23.9535 43.1641 23.1445C43.1641 22.3355 42.5082 21.6797 41.6992 21.6797Z",
    fill: "#FBB132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.9258 17.5781H7.32422C6.51523 17.5781 5.85938 18.234 5.85938 19.043V24.9023C5.85938 25.7113 6.51523 26.3672 7.32422 26.3672H23.9258C24.7348 26.3672 25.3906 25.7113 25.3906 24.9023V19.043C25.3906 18.234 24.7348 17.5781 23.9258 17.5781ZM22.4609 23.4375H8.78906V20.5078H22.4609V23.4375Z",
    fill: "#FBB132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.9258 29.2969H7.32422C6.51523 29.2969 5.85938 29.9527 5.85938 30.7617V36.6211C5.85938 37.4301 6.51523 38.0859 7.32422 38.0859H23.9258C24.7348 38.0859 25.3906 37.4301 25.3906 36.6211V30.7617C25.3906 29.9527 24.7348 29.2969 23.9258 29.2969ZM22.4609 35.1562H8.78906V32.2266H22.4609V35.1562Z",
    fill: "#FBB132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.42188 8.78906C8.23089 8.78906 8.88672 8.13323 8.88672 7.32422C8.88672 6.51521 8.23089 5.85938 7.42188 5.85938C6.61286 5.85938 5.95703 6.51521 5.95703 7.32422C5.95703 8.13323 6.61286 8.78906 7.42188 8.78906Z",
    fill: "#FBB132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.2812 8.78906C14.0903 8.78906 14.7461 8.13323 14.7461 7.32422C14.7461 6.51521 14.0903 5.85938 13.2812 5.85938C12.4722 5.85938 11.8164 6.51521 11.8164 7.32422C11.8164 8.13323 12.4722 8.78906 13.2812 8.78906Z",
    fill: "#FBB132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.1406 8.78906C19.9496 8.78906 20.6055 8.13323 20.6055 7.32422C20.6055 6.51521 19.9496 5.85938 19.1406 5.85938C18.3316 5.85938 17.6758 6.51521 17.6758 7.32422C17.6758 8.13323 18.3316 8.78906 19.1406 8.78906Z",
    fill: "#FBB132"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.7d7d1b3cd2edcbfe6329ceb45a6cd958.svg";
export { ForwardRef as ReactComponent };